import { CoreTypesApiPaths, CoreTypesComponents } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'

const client = new RestClient(CoreTypesApiPaths.ResetPasswordController_request, {}, resolveDomain(), { mode: 'cors', referrerPolicy: 'no-referrer' })

export const resetPasswordRequestHandler = async (data: CoreTypesComponents['schemas']['RequestResetPasswordDto']) => {
  await client.post<CoreTypesComponents['schemas']['RequestResetPasswordDto'], Response>('', data, {
    'Content-Type': 'application/json',
  })
}
